export default __webpack_public_path__ + "static/media/expoindo-8.58b8eaf0.jpg";